import React, { FC } from "react";

import { Clickable } from "../../buttons/button/clickable";
import { Cta } from "../../buttons/cta";
import { Spinner } from "../../spinner";

interface Props {
  logged: boolean;
  checking: boolean;
  labels: Record<string, string | null>;
  onDownloadCatalog: () => void;
  onLogin: () => void;
  catalogUrl: string;
}

export const ProductStripCatalogCta: FC<Props> = ({
  checking,
  labels,
  logged,
  onDownloadCatalog,
  catalogUrl,
  onLogin,
}) => {
  return logged ? (
    <Cta
      onClick={onDownloadCatalog}
      variant="primary"
      label={labels["product-download-catalog-card-cta-label"]}
      externalUrl={catalogUrl}
      pageLink={null}
      disabled={checking}
    />
  ) : checking ? (
    <div className="h-14 flex items-center justify-center">
      <Spinner size="small" />
    </div>
  ) : (
    <Clickable variant="primary" onClick={onLogin}>
      {labels["product-download-catalog-card-cta-please-login"]}
    </Clickable>
  );
};
